import React, { useState, useEffect, useMemo } from 'react';
import * as JsSearch from 'js-search';

export default function SearchInput({
  indexIdField,
  indexFields,
  documents,
  className,
  onSearch,
  inputRef,
  clear,
  tabIndex,
}) {
  const [searchText, setSearchText] = useState('');
  const searchIndex = useMemo(() => {
    const idx = new JsSearch.Search(indexIdField);
    indexFields.forEach((field) => {
      idx.addIndex(field);
    });

    idx.addDocuments(documents);

    return idx;
  }, [documents, indexFields, indexIdField]);

  function handleInputChange(evt) {
    setSearchText(evt.target.value);
  }

  useEffect(() => {
    if (searchIndex) onSearch(searchIndex.search(searchText));
  }, [searchText]); //eslint-disable-line

  useEffect(() => {
    setSearchText('');
  }, [clear]);

  return (
    <input
      ref={inputRef}
      type="text"
      value={searchText}
      onChange={handleInputChange}
      className={className}
      tabIndex={tabIndex}
    />
  );
}
